import { SVGProps } from 'react';

export type ThumbsUpFilledProps = SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};

export const ThumbsUpFilled = ({
  size = 20,
  color = 'currentColor',
  ...props
}: ThumbsUpFilledProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill={color}
      {...props}
    >
      <path d="M234,80.12A24,24,0,0,0,216,72H160V56a40,40,0,0,0-40-40,8,8,0,0,0-7.16,4.42L75.06,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H204a24,24,0,0,0,23.82-21l12-96A24,24,0,0,0,234,80.12Z" />
    </svg>
  );
};
